import { useState } from "react";
import { getFunctions, httpsCallable } from "firebase/functions";
import { stripePromise } from "../utils/stripe";

export const useStripe = () => {
  const [loading, setLoading] = useState(false);
  const functions = getFunctions();

  // Helper to save state before redirecting
  const saveContextBeforeRedirect = () => {
    // Store the FULL current URL
    const currentUrl = window.location.href;
    sessionStorage.setItem("stripe_return_url", currentUrl);

    // Get current selection/input from window global
    const currentSelection = (window as any).__currentSelection;
    const currentInput = (window as any).__currentInputValue;

    const currentProjectId = sessionStorage.getItem("currentProjectId");

    if (currentProjectId) {
      sessionStorage.setItem("stripe_return_project", currentProjectId);

      if (currentSelection && currentSelection.length > 0) {
        sessionStorage.setItem(
          "stripe_return_selection",
          JSON.stringify(currentSelection)
        );
      }
      
      if (currentInput) {
         sessionStorage.setItem(
          "stripe_return_context", // Legacy key used in RightSidebar
          JSON.stringify({ input: currentInput })
        );
      }
    }
  };

  const purchaseCredits = async (
    creditAmount: number,
    price: number,
    userId: string
  ) => {
    setLoading(true);
    try {
      saveContextBeforeRedirect();

      // Base success URL - always return to root with a flag
      const baseUrl = window.location.origin;
      const successUrl = baseUrl + "/?stripe_return=success";
      const cancelUrl = baseUrl + "/?stripe_return=canceled";

      const createCreditCheckoutSession = httpsCallable(
        functions,
        "createCreditCheckoutSession"
      );
      const { data } = await createCreditCheckoutSession({
        creditAmount,
        price,
        userId,
        successUrl,
        cancelUrl,
      });

      const stripe = await stripePromise;
      if (stripe) {
        await stripe.redirectToCheckout({
          sessionId: (data as any).sessionId,
        });
      }
    } catch (error) {
      // console.error("Error purchasing credits:", error);
      throw error;
    } finally {
      setLoading(false);
    }
  };

  const subscribeToPlan = async (priceId: string) => {
    setLoading(true);
    try {
      saveContextBeforeRedirect();

      const baseUrl = window.location.origin;
      // We use the same return flag; the profile check on load handles the rest
      const successUrl = baseUrl + "/?stripe_return=success";
      const cancelUrl = baseUrl + "/?stripe_return=canceled";

      const createSubscriptionSession = httpsCallable(
        functions,
        "createSubscriptionCheckoutSession"
      );

      const { data } = await createSubscriptionSession({
        priceId,
        successUrl,
        cancelUrl,
      });

      const stripe = await stripePromise;
      if (stripe) {
        await stripe.redirectToCheckout({
          sessionId: (data as any).sessionId,
        });
      }
    } catch (error) {
      console.error("Error subscribing:", error);
      throw error;
    } finally {
      setLoading(false);
    }
  };

  return {
    purchaseCredits,
    subscribeToPlan,
    loading,
  };
};